export class CameraFrameMonitor {
    constructor({
        windowLike = globalThis.window,
        onFrame,
    } = {}) {
        this.window = windowLike;
        this.onFrame = onFrame;
        this.video = null;
        this.running = false;
        this.handle = null;
        this.lastMediaTime = null;
    }

    start(video) {
        this.stop();
        this.video = video;
        this.running = true;
        this.lastMediaTime = null;
        this.schedule();
    }

    schedule() {
        if (!this.running || !this.video) {
            return;
        }

        if (typeof this.video.requestVideoFrameCallback === 'function') {
            this.handle = this.video.requestVideoFrameCallback(
                (timestamp, metadata) => {
                    if (!this.running) {
                        return;
                    }

                    this.onFrame?.(timestamp, metadata);
                    this.schedule();
                }
            );
            return;
        }

        this.handle = this.window?.requestAnimationFrame?.((timestamp) => {
            if (!this.running) {
                return;
            }

            const mediaTime = this.video?.currentTime;

            if (mediaTime !== this.lastMediaTime) {
                this.lastMediaTime = mediaTime;
                this.onFrame?.(timestamp, { mediaTime });
            }

            this.schedule();
        });
    }

    stop() {
        this.running = false;

        if (this.handle !== null && this.video) {
            if (typeof this.video.cancelVideoFrameCallback === 'function') {
                this.video.cancelVideoFrameCallback(this.handle);
            } else {
                this.window?.cancelAnimationFrame?.(this.handle);
            }
        }

        this.handle = null;
        this.video = null;
        this.lastMediaTime = null;
    }
}
